module.exports = __webpack_public_path__ + "static/media/AboutUS.07b7103d.jpg";